var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-img',{staticClass:"my-3",attrs:{"src":require('../../assets/beobasta.png'),"contain":"","height":"200","dark":""}})],1)],1),_c('p',[_vm._v("Error")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }